import React from "react";

export const GrainOverlay = () => {
  return <div className="grain" data-testid="grain-overlay" aria-hidden="true" />;
};

export default GrainOverlay;
